import type { ComputedRef, InjectionKey } from 'vue'
import type { AnyFunction } from '@sgui-plus/utils/types'
import type { ComponentSize } from '@sgui-plus/utils/size'

export type CheckboxValueType = string | number | boolean

export interface ICheckboxGroupInstance {
  name?: string
  modelValue?: ComputedRef
  disabled?: ComputedRef<boolean>
  min?: ComputedRef<number>
  max?: ComputedRef<number>
  size?: ComputedRef<string>
  fill?: ComputedRef<string>
  textColor?: ComputedRef<string>
  checkboxGroupSize?: ComputedRef<ComponentSize>
  changeEvent?: AnyFunction<any>
}

export const CheckboxGroupContextKey: InjectionKey<any> = Symbol('CheckboxGroupContextKey')
